module.exports = __webpack_public_path__ + "media/images/countryrect/fj-8ae2309b309626ddf912bae3bc40e026.svg";